// Fonction pour ouvrir la base de données
export const openDB = async (): Promise<IDBDatabase> => {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open("MyDatabase", 1);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBRequest).result as IDBDatabase; // Cast explicite ici
      db.createObjectStore("dataStore", { keyPath: "key" });
    };

    request.onsuccess = (event) => {
      const db = (event.target as IDBRequest).result as IDBDatabase; // Cast explicite ici
      resolve(db); // On renvoie la base de données une fois qu'elle est ouverte
    };

    request.onerror = (event) => {
      reject((event.target as IDBRequest).error); // Gérer l'erreur avec cast explicite
    };
  });
};

// Fonction pour sauvegarder une donnée générique dans IndexedDB
export const saveData = async (key: string, value: any): Promise<void> => {
  const db = await openDB();
  const tx = db.transaction("dataStore", "readwrite");
  const store = tx.objectStore("dataStore");
  store.put({ key, value }); // Enregistrer la donnée sous la clé spécifiée
  await tx.oncomplete; // Attendre que la transaction soit terminée
};

// Fonction pour récupérer une donnée avec une clé
export const getData = async (key: string): Promise<any | null> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction("dataStore", "readonly");
    const store = transaction.objectStore("dataStore");
    const request = store.get(key);

    request.onsuccess = (event) => {
      const result = (event.target as IDBRequest).result;
      if (result) {
        try {
          const parsedValue =
            typeof result.value === "string"
              ? JSON.parse(result.value)
              : result.value;
          resolve(parsedValue);
        } catch (error) {
          console.error("Erreur de parsing JSON:", error);
          resolve(null);
        }
      } else {
        resolve(null);
      }
    };

    request.onerror = (event) => reject((event.target as IDBRequest).error);
  });
};

export const returnedData = async (parametre: any) => {
  return await getData(parametre);
};
